import styled, { css } from 'styled-components';
import { media, darken, variables, theme } from '../../themes/theme';
export default styled.span `
  display: inline-flex;
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  height: ${props => (props.isBackLink ? '100%' : '1.375rem')};

  path {
    transition: fill 0.4s linear;
  }

  &:hover {
    cursor: pointer;

    path:first-of-type {
      ${({ isWhiteTextLink, isCoupon }) => isWhiteTextLink
    ? css `
              opacity: 0.8;
              transition: opacity 0.4s linear;
            `
    : css `
              fill: ${!isCoupon &&
        darken(variables.DarkenFactor, theme.BrandPrimary)};
              transition: fill 0.4s linear;
            `}
    }
  }

  ${media.tablet `
    height: 1.375rem;
  `}
`;
